module.exports = __webpack_public_path__ + "static/media/Aastha.9b0fff1e.png";